<template lang='pug'>
  bf-overlay(v-if='rsv' @close='rsv = false')
    template(v-slot:heading)
      h5.section-heading {{ $t('Reservation/Appointment Details') }}

    rsv-dtls.overlay(
      v-if='rsv'
      :rsv='rsv'
      :options='{ show: { biz: true, cus: false } }'
    )

    rsv-msgs#rsv-msgs(
      v-if='rsv && account'
      :rsv='rsv'
      :account='account'
      :key='rsv.id'
    )

  carousel.rsv-car.component(
    v-else
    :perPageCustom="[[180, 1], [360, 2], [540, 3], [720, 4], [900, 5]]"
    :scrollPerPage='false'
    :paginationEnabled="false"
    :navigationEnabled='true'
    :navigateTo='start'
    :key='rsvs.length'
  )
    slide.slide( v-for='r, i in rsvs' :key='`slide-${r.id}`' )
      rsv-card(
        :rsv='r'
        :i='i'
        :reservations='rsvs'
        :key='r.id'
        @click.native='rsv = r'
      )
</template>

<script>
  import { db } from '@/main'
  import { Carousel, Slide } from 'vue-carousel'
  import RsvCard from '@/components/rsv-card'

  export default {
    name: 'rsv-car.component',

    components: {
      RsvCard,
      Carousel,
      Slide
    },

    props: {
      user: Object,
      account: [ Object, Array ],
      merchant: { default: false }
    },

    data() {
      return {
        rsv: false,
        rsvs: []
      }
    },

    computed: {
      start() {
        return this.rsvs.findIndex( r =>
          !r.status || r.status == 'Active' &&
          r.datetime.start.toDate() > new Date()
        )
      }
    },

    firestore() {
      return {
        rsvs: {
          ref: db.collection('reservations')
            .where( 'business_id', '==', this.$route.params.id )
            .where( 'account_id', '==', this.account.id )
            .orderBy('datetime.end', 'desc'),
          
          resolve: docs => this.$emit( 'counted', docs.filter( r => r.datetime.end.toDate() < new Date() ).length )
        }
      }
    },

    watch: {
      rsvs(curr, prev) {
        this.$emit( 'counted', curr.filter( r => r.datetime.end.toDate() < new Date() ).length )
      }
    },

    methods: {
      rsv_details(i) {
        this.rsv = this.rsvs[i]
        this.show.rsv = true
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .rsv-car
    .slide
      // padding 8px
      // padding-right 1px
      box-sizing border-box
      > *
        margin-left 16px
      &:first-child > *
        margin-left 0
        
</style>
